import { render, staticRenderFns } from "./CustomTagsMultiselect.vue?vue&type=template&id=30018150"
import script from "./CustomTagsMultiselect.vue?vue&type=script&lang=ts"
export * from "./CustomTagsMultiselect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30018150')) {
      api.createRecord('30018150', component.options)
    } else {
      api.reload('30018150', component.options)
    }
    module.hot.accept("./CustomTagsMultiselect.vue?vue&type=template&id=30018150", function () {
      api.rerender('30018150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/customOptions/CustomTagsMultiselect.vue"
export default component.exports